<template>
  <div>
    <div style="padding-bottom:10vh;" v-if="isMobileOrTablet">
      <appHeader></appHeader>
      <div class="container-fluid account">
        <div class="row">
          <div class="col-sm-12 pr-0">
            <appAccountSidebar></appAccountSidebar>
          </div>
          <transition appear name="fade">
            <div v-if="orders.length === 0" class="text-center">
              <h6 class="mt-4">No orders to show yet</h6>
              <img
                alt="no orders"
                class="m-4 b-4"
                src="../../assets/images/list.png"
                style="max-width:400px"
              />
            </div>
            <div v-else class="px-4">
              <h4>Your orders status</h4>
              <div
                v-for="order in orders"
                :key="order.number"
                class="order row mb-4 justify-content-center"
              >
                <div class="col-md-2 pb-3 pr-4">
                  <img
                    :alt="order.productName"
                    :src="order.productImageUrl"
                    class="rounded "
                  />
                </div>
                <div class="col-md-9 row">
                  <div class="row prod-data mb-2 p-1">
                    <div class="col-md-2 col-4">
                      <strong>Order #</strong>{{ order.number }}
                      <span v-if="order.bestBuyOrderId"><br><strong>BBY : </strong>{{ order.bestBuyOrderId }}</span>
                    </div>
                    <div class="col-md-2 col-4">
                      <strong>Date </strong>{{ order.date | formatDate }}
                    </div>
                    <div class="col-md-2 col-4">
                      <strong>Quantity </strong>{{ order.productQuantity }}
                    </div>
                    <div class="col-md-2 col-4">
                      <strong>Product Number </strong>{{ order.productId }}
                    </div>
                    <div v-if="order.carrierCode !== ''" class="col-md-2 col-4">
                      <strong>Courier </strong>{{ order.carrierCode }}
                      <span v-if=" order.dateProcessed"><br><strong>Estimated Delivery:</strong> {{ HumanReadableDateFormat(order.dateProcessed, true) }}</span>
                      <span v-if="order.bestBuyOrderTrackingDetails"><br><strong>Status:</strong>{{ JSON.parse(order.bestBuyOrderTrackingDetails)['status'] }}</span>
                    </div>
                    <div
                      v-if="
                        order.trackingNumber !== '' &&
                          order.trackingUrl !== null
                      "
                      class="col-md-2 col-4"
                    >
                      <strong>Tracking Number </strong>
                      <a
                        :href="order.trackingUrl"
                        v-if="order.trackingUrl !== null"
                        class=""
                        target="_blank"
                        >{{ order.trackingNumber }}</a
                      >
                    </div>
                    <div
                      v-else-if="order.trackingNumber !== ''"
                      class="col-md-2 col-4"
                    >
                      <strong>Tracking Number </strong>
                      {{ order.trackingNumber }}
                    </div>
                  </div>
                  <div class="col-md-12 px-0 my-2">
                    <router-link
                      :to="{
                        name: 'Product',
                        params: { productId: order.productId },
                      }"
                      ><h5>
                        {{ order.productName }} {{ order.options }}
                      </h5></router-link
                    >
                    <p class="price">
                      <strong>{{ order.points | numToLocale }}</strong> Points
                      redeemed
                    </p>
                    <!--                  <button class="btn btn-primary d-inline-block my-3 mr-3">-->
                    <!--                    <font-awesome-icon icon="question-circle"/>-->
                    <!--                    Get help with this order-->
                    <!--                  </button>-->
                    <router-link
                      :to="{
                        name: 'Product',
                        params: { productId: order.productId },
                      }"
                      class="d-inline-block"
                    >
                      <font-awesome-icon class="mr-1" icon="cart-plus" />
                      Buy again
                    </router-link>
                    &nbsp;&nbsp;<a href="javascript:void(0)" @click="fetchShippingDetail(order.bestBuyOrderId)"><font-awesome-icon class="mr-1" icon="truck" />Track Order<i class="fas fa-spinner fa-spin" v-if="isDisabled"></i></a>
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </transition>
        </div>
      </div>
      <appFooter></appFooter>
      <navigationFooter></navigationFooter>
    </div>
    <div v-else class="mt-5">
      <appHeader></appHeader>
      <div class="container-fluid account">
        <div class="row">
          <div class="col-md-3 col-sm-12 pr-0 dark-bg">
            <appAccountSidebar></appAccountSidebar>
          </div>
          <transition appear name="fade">
            <div v-if="orders.length === 0" class="col-md-9 text-center">
              <h6 class="mt-4">No orders to show yet</h6>
              <img
                alt="no orders"
                class="m-4 b-4"
                src="../../assets/images/list.png"
                style="max-width:400px"
              />
            </div>
            <div v-else class="col-md-9 p-4">
              <h4>Your orders status</h4>
              <div v-for="order in orders" :key="order.number" class="order row mb-4">
                <div class="col-md-2 pb-3 pr-4">
                  <img
                    :alt="order.productName"
                    :src="order.productImageUrl"
                    class="rounded "
                  />
                </div>
                <div class="col-md-9 row">
                  <div class="row prod-data mb-2">
                    <div class="col-md-2">
                      <strong>Order #</strong>{{ order.number }}
                      <span v-if="order.bestBuyOrderId"><br><strong>BBY : </strong>{{ order.bestBuyOrderId }}</span>
                    </div>
                    <div class="col-md-2">
                      <strong>Date </strong>{{ order.date | formatDate }}
                    </div>
                    <div class="col-md-2">
                      <strong>Quantity </strong>{{ order.productQuantity }}
                    </div>
                    <div class="col-md-2">
                      <strong>Product Number </strong>{{ order.productId }}
                    </div>
                    <div v-if="order.carrierCode !== ''" class="col-md-2">
                      <strong>Courier </strong>{{ order.carrierCode }}
                      <span v-if=" order.dateProcessed"><br><strong>Estimated Delivery:</strong> {{ HumanReadableDateFormat(order.dateProcessed, true) }}</span>
                      <span v-if="order.bestBuyOrderTrackingDetails"><br><strong>Status:</strong>{{ JSON.parse(order.bestBuyOrderTrackingDetails)['status'] }}</span>
                    </div>
                    <div
                      v-if="
                        order.trackingNumber !== '' &&
                          order.trackingUrl !== null
                      "
                      class="col-md-2"
                    >
                      <strong>Tracking Number </strong>
                      <a
                        :href="order.trackingUrl"
                        v-if="order.trackingUrl !== null"
                        class=""
                        target="_blank"
                        >{{ order.trackingNumber }}</a
                      >
                    </div>
                    <div
                      v-else-if="order.trackingNumber !== ''"
                      class="col-md-2"
                    >
                      <strong>Tracking Number </strong>
                      {{ order.trackingNumber }}
                    </div>
                  </div>
                  <div class="col-md-12 px-0 my-2">
                    <router-link
                      :to="{
                        name: 'Product',
                        params: { productId: order.productId },
                      }"
                      ><h5>
                        {{ order.productName }} {{ order.options }}
                      </h5></router-link
                    >
                    <div>
                      <p class="price" v-if="order.supplierSaleTax" :style="{ 'margin': 'unset' }">
                        <strong>{{ order.points }}</strong> Product point
                      </p>
                      <p class="price" v-if="order.supplierSaleTax" :style="{ 'margin': 'unset' }">
                        <strong>{{ order.supplierSaleTax }}</strong> Sales tax point
                      </p>
                      <p class="price">
                        <strong>{{ (order.points + order.supplierSaleTax) | numToLocale }}</strong> Total Points redeemed
                      </p>
                    </div>
                    <!--                  <button class="btn btn-primary d-inline-block my-3 mr-3">-->
                    <!--                    <font-awesome-icon icon="question-circle"/>-->
                    <!--                    Get help with this order-->
                    <!--                  </button>-->
                    <router-link
                      :to="{
                        name: 'Product',
                        params: { productId: order.productId },
                      }"
                      class="d-inline-block"
                    >
                      <font-awesome-icon class="mr-1" icon="cart-plus" />
                      Buy again
                    </router-link>
                    &nbsp;&nbsp;<a href="javascript:void(0)" @click="fetchShippingDetail(order.bestBuyOrderId)"><font-awesome-icon class="mr-1" icon="truck" />Track Order<i class="fas fa-spinner fa-spin" v-if="isDisabled"></i></a>
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </transition>
        </div>
      </div>
      <appFooter></appFooter>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AccountSidebar from "./AccountSidebar.vue";
import navigationFooter from "../../components/navigationFooter.vue";
import { isMobile, isTablet } from "mobile-device-detect";
import { mapState } from "vuex";
import FrontendService from "../../services/FrontendService"

export default {
  components: {
    appHeader: Header,
    appFooter: Footer,
    appAccountSidebar: AccountSidebar,
    navigationFooter: navigationFooter,
  },
  data() {
    return {
      isDisabled: false,
    };
  },
  computed: {
    ...mapState({
      orders: (state) => state.user.orders,
    }),
    isMobileOrTablet: function() {
      return isMobile || isTablet;
    },
  },
  methods: {
    fetchShippingDetail(bestBuyOrderId) {
      this.isDisabled = true;
      let data = { bestBuyOrderId: bestBuyOrderId };
      FrontendService.fetchShippingDetail(data)
        .then((response) => {
          this.isDisabled = false;
          if (response.status != 400) {
            this.$store.dispatch("user/fetchOrders");
            let trackingLink = "https://www.ship24.com/tracking?p="+response.data.data['tracking-number'];
            window.open(trackingLink, '_blank', 'noreferrer');
          } else {
            alert(response.data.responseMessage);
          }
        }).catch((e) => {
          this.isDisabled = false;
          alert(e.response.data.responseMessage);
        });
    },
    HumanReadableDateFormat(date, onlyDate = false) {
          const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June",
          "July", "Aug", "Sept", "Oct", "Nov", "Dec"
          ];
          let dt = new Date(date);
          if (dt == "Invalid Date") {
              return "-";
          }
          let day = ("0" + dt.getDate()).slice(-2);
          let month = dt.getMonth();
          let year = dt.getFullYear();
          let hour = ("0" + dt.getHours()).slice(-2);
          let minute = ("0" + dt.getMinutes()).slice(-2);
          let seconds = ("0" + dt.getSeconds()).slice(-2);
          if (onlyDate) {
              return day + " " + monthNames[month] + " " + year;
          } else {
              return day + " " + monthNames[month] + " " + year + " " + hour + ":" + minute + ":" + seconds;
          }
      },
  },
  created() {
    this.$store.dispatch("user/fetchOrders");
  },
};
</script>

<style lang="scss">
.order {
  img {
    max-width: 100%;
  }
  .prod-data {
    color: $gray-600;
    font-size: 0.8rem;
    strong {
      display: block;
    }
  }
  .price {
    font-size: 1.1em;
    strong {
      font-size: 1.1em;
      font-weight: 700;
    }
  }
  h5::after {
    display: none;
  }
}
</style>
